import cryptoRandomString from 'crypto-random-string';

export default {
  registerSuccessNotification: function ({ state, commit }, success_notification) {
    let success_notification_id = cryptoRandomString({ length: 6 });
    commit("addSuccessNotification",
      {
        id: success_notification_id,
        timer: state.success_notification_time,
        title: success_notification.title,
        message: success_notification.message
      }, success_notification_id);

    let sn_interval = setInterval(() => {
      commit("reduceTimer", { success_notification_id: success_notification_id, time_reduce: state.time_reduce })
    }, state.time_reduce);

    setTimeout(() => {
      clearInterval(sn_interval);
    }, state.success_notification_time);

    setTimeout(() => {
      commit("removeSuccessNotification", success_notification_id)
    }, state.success_notification_time);
  },
}